import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class LoadingService implements OnDestroy {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private isDestroyed = false;
  private activeRequests = 0;
  loading$ = this.loadingSubject.asObservable();

  show(): void {
    try {
      if (this.isDestroyed) {
        console.warn(
          'LoadingService.show() called after service was destroyed'
        );
        return;
      }
      if (!environment.production) {
        // Lightweight dev-time log (no expensive stack generation by default)
        console.debug('🔄 LoadingService.show()');
      }
      this.activeRequests++;
      if (this.activeRequests === 1) {
        this.loadingSubject.next(true);
      }
    } catch (error) {
      console.error('Error in LoadingService.show():', error);
    }
  }

  hide(): void {
    try {
      if (this.isDestroyed) {
        console.warn(
          'LoadingService.hide() called after service was destroyed'
        );
        return;
      }
      if (!environment.production) {
        console.debug('✅ LoadingService.hide()');
      }
      this.activeRequests = Math.max(0, this.activeRequests - 1);
      if (this.activeRequests === 0) {
        this.loadingSubject.next(false);
      }
    } catch (error) {
      console.error('Error in LoadingService.hide():', error);
    }
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    try {
      this.loadingSubject.complete();
    } catch (error) {
      console.error('Error in LoadingService.ngOnDestroy():', error);
    }
  }
}
